<div class="ticket">
  <div id="dvContainer" class="grid">
    <div class="col-12">
      <div class="grid">
        <div
          id="logo"
          class="col-12 flex align-items-center justify-content-center"
        >
          <!-- <img
            src="https://i.ibb.co/R9gWWRK/inkafarmadesk.jpg"
            alt="inkafarmadesk"
            class="center"
            style="height: 100px; width: 200px; border: none"
          /> -->
        </div>
        <div id="businessName" class="col-12 m-0 p-0 text-2xl text-center">
          {{ dataForVoucher.document.businessName }}
        </div>
        <div id="rucBusiness" class="col-12 m-0 p-0 text-xl text-center">
          R.U.C.: {{ dataForVoucher.document.businessRuc }}
        </div>
        <div id="businnesAdress" class="col-12 m-0 p-0 text-xl text-center">
          {{ dataForVoucher.document.businessAddressFiscal }}
        </div>
        <div
          id="typeVoucher"
          class="col-12 m-0 p-0 font-bold text-2xl text-center"
        >
          {{ dataForVoucher.document.typeVoucher }}
        </div>
        <div
          id="voucherNumber"
          class="col-12 m-0 p-0 text-blue-600 text-xl text-center"
        >
          {{ dataForVoucher.document.numberDocument }}
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="grid flex ml-1 mr-1" id="clientDetails">
        <div class="col-12 m-0 p-0">
          FECHA: {{ date }}
        </div>
        <div class="col-12 m-0 p-0">
          HORA: {{ time  }}
        </div>
        <div class="col-12 m-0 p-0">
          NOMBRES: {{ dataForVoucher.document.clientName | uppercase }}
        </div>
        <div class="col-12 m-0 p-0">
          DIRECCION: {{ dataForVoucher.document.clientAddress }}
        </div>
        <div class="col-12 m-0 p-0">
          DOCUMENTO: {{ dataForVoucher.document.clientIdentifier }}
        </div>
        <div class="col-12 m-0 p-0">
          N° DE DOCUMENTO: {{ dataForVoucher.document.clientIdNumber }}
        </div>
        <div class="col-12 m-0 p-0">
          PAGO: CONTADO
        </div>
      </div>
    </div>

    <div class="col-12 ">
      <p-table
        [value]="dataForVoucherFlattened"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="font-bold text-left">DESCRIPCIÓN</th>
            <th class="font-bold text-center" >CANT.</th>
            <th class="font-bold text-center">P.U.</th>
            <th class="font-bold text-center">TOTAL</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td class="text-left">
              {{ product.description }} {{ product.format | uppercase }}
            </td>
            <td class="text-center">
              {{ product.quantity | number: '1.0' }}
            </td>
            <td class="text-center">
              {{ product.priceUnit  }}
            </td>
            <td class="text-center">
              {{ product.price  }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td class="text-left">SUB-TOTAL</td>
            <td></td>
            <td></td>
            <td class="text-right">
              {{ dataForVoucher.document.amount *0.82 | currency: 'PEN' }}
            </td>
          </tr>
          <tr>
            <td class="text-left">DESCUENTO</td>
            <td></td>
            <td></td>
            <td class="text-right">
              {{ 0.00 | currency: 'PEN' }}
            </td>
          </tr>
          <tr>
            <td class="text-left">I.G.V.</td>
            <td></td>
            <td></td>
            <td class="text-right">
              {{ dataForVoucher.document.amount * 0.18 | currency: 'PEN' }}
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="2">TOTAL A PAGAR</td>
            <td></td>
            <td class="text-right">
              {{ dataForVoucher.document.amount | currency: 'PEN' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="col-12 h-40rem">
      <div class="grid flex ml-1 mr-1" id="clientDetails">
        <div class="col-12 m-0 p-0">SON : {{ newAmount | uppercase }}</div>
        <div class="col-12 m-0 p-0">FORMA DE PAGO : {{ methodPaymentName }} </div>
        <div class="col-12 m-0 p-0">
          PAGO CON :
          {{ dataForVoucher.document.payWith | currency: 'PEN' }}
        </div>
        <div class="col-12 m-0 p-0">
          VUELTO :
          {{
          dataForVoucher.document.payWith - dataForVoucher.document.amount
            | currency: 'PEN'
          }}
        </div>
        <div class="col-12 m-0 p-0">
          CAJERO : {{ newUserUsername | uppercase }}
        </div>

        <div class="col-12 m-0 p-0" *ngIf="qrCodeImage">
          <img
            [src]="qrCodeImage"
            alt="Código QR de la venta"
            class="w-10rem h-10rem"
          />
        </div>
      </div>
    </div>

  </div>
</div>

